import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';

const stats = [
  { value: '10万+', label: '每日活跃用户' },
  { value: '5000+', label: '累计爆料内容' },
  { value: '99.7%', label: '用户满意度' },
  { value: '24/7', label: '全天候更新' },
];

const aboutJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '关于黑料视频',
  description: '黑料视频是国内领先的娱乐八卦爆料资讯平台，提供黑料视频在线观看与下载，黑料24小时不打烊每日更新。',
  url: 'http://chiguabao.cn/about',
};

export default function AboutPage() {
  useEffect(() => {
    document.title = '关于我们 - 黑料视频 | 品牌介绍与联系方式';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        '黑料视频品牌介绍、用户口碑与联系方式。国内领先的娱乐八卦爆料平台，24小时不打烊每日更新最新黑料爆料内容。'
      );
    }
  }, []);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutJsonLd) }}
      />
      <div className="min-h-screen bg-background-100">
        <Navbar />

        <section className="pt-24 md:pt-28 pb-12 md:pb-16 px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: '关于我们' },
            ]}
          />

          <div className="max-w-[1100px] mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16">
              <div>
                <span className="text-xs font-medium text-foreground-500 uppercase tracking-wider whitespace-nowrap">
                  关于黑料视频
                </span>
                <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 mt-4 leading-tight">
                  国产黑料视频<br />实时追踪平台
                </h1>
              </div>
              <div className="flex items-start">
                <p className="text-base md:text-lg text-foreground-700 leading-relaxed">
                  黑料视频成立于2024年，是国内领先的娱乐八卦爆料资讯平台。我们致力于为吃瓜群众提供最新最全的黑料爆料内容，包括<strong>黑料视频在线观看</strong>与<strong>黑料视频下载</strong>服务。平台秉持"<strong>黑料24小时不打烊</strong>"的理念，每日更新最新内容，覆盖明星黑料、网红爆料、社会热点等多个领域。我们的编辑团队深耕娱乐圈多年，拥有丰富的行业资源和敏锐的新闻嗅觉，确保每一条爆料都经过严格审核，真实可靠。
                </p>
              </div>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 mt-16 md:mt-20">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-primary-600">
                    {stat.value}
                  </div>
                  <p className="mt-2 text-sm text-foreground-500">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="max-w-[1100px] mx-auto px-4 md:px-6 py-12 md:py-20">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              <a href="#why-us">为什么选择黑料视频</a>
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            <div className="p-6 md:p-8 bg-background-50 rounded-lg border border-background-200/70">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                <i className="ri-flashlight-line text-xl"></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-foreground-900 mb-2">
                <a href="#feature-speed">极速更新</a>
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                黑料24小时不打烊，编辑团队全天候追踪最新爆料，确保您第一时间获取最热黑料资讯。每日更新超过10条独家爆料内容。
              </p>
            </div>
            <div className="p-6 md:p-8 bg-background-50 rounded-lg border border-background-200/70">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                <i className="ri-shield-check-line text-xl"></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-foreground-900 mb-2">
                <a href="#feature-quality">真实可靠</a>
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                所有黑料内容均经过专业团队多方核实，杜绝虚假谣言。我们坚持做有态度的吃瓜平台，不为流量牺牲内容质量。
              </p>
            </div>
            <div className="p-6 md:p-8 bg-background-50 rounded-lg border border-background-200/70">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                <i className="ri-global-line text-xl"></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-foreground-900 mb-2">
                <a href="#feature-coverage">全网覆盖</a>
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                从明星黑料到网红爆料，从社会热点到综艺吃瓜，国产黑料视频实时追踪，一站式覆盖所有吃瓜需求，让您不错过任何精彩。
              </p>
            </div>
          </div>
        </section>

        <section className="max-w-[1100px] mx-auto px-4 md:px-6 py-12 md:py-20">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              <a href="#user-reviews">用户口碑</a>
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {[
              { name: '吃瓜老司机', text: '黑料视频真的太强了！每天都有新鲜热乎的黑料，更新速度全网最快。自从关注了黑料视频，我再也没有错过任何热点八卦，强烈推荐！', rating: 5 },
              { name: '娱乐圈观察家', text: '作为一个追星十年的老粉，黑料视频是我每天必刷的网站。内容真实可靠，分析到位，不会为了流量乱写。黑料24小时不打烊不是吹的。', rating: 5 },
              { name: '八卦爱好者', text: '国产黑料视频实时追踪做得太棒了！分类清晰，浏览方便，手机上也能看。现在吃瓜就靠黑料视频了，已经推荐给身边所有朋友。', rating: 5 },
            ].map((review) => (
              <div key={review.name} className="p-6 md:p-8 bg-background-50 rounded-lg border border-background-200/70">
                <div className="flex items-center gap-1 mb-4">
                  {Array.from({ length: review.rating }).map((_, i) => (
                    <span key={i} className="w-4 h-4 flex items-center justify-center text-accent-500">
                      <i className="ri-star-fill text-sm"></i>
                    </span>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-5">&ldquo;{review.text}&rdquo;</p>
                <div className="flex items-center gap-3">
                  <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-sm font-bold">
                    {review.name.charAt(0)}
                  </span>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">{review.name}</p>
                    <p className="text-xs text-foreground-500">忠实用户</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="max-w-[1100px] mx-auto px-4 md:px-6 py-12 md:py-20">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              <a href="#contact-us">联系我们</a>
            </h2>
            <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
              如果您有独家爆料或合作意向，欢迎通过以下方式联系我们
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 max-w-[900px] mx-auto">
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <span className="w-10 h-10 flex items-center justify-center shrink-0 rounded-full bg-primary-100 text-primary-600">
                  <i className="ri-mail-line"></i>
                </span>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-900">
                    <a href="#email-contact">电子邮箱</a>
                  </h3>
                  <p className="text-sm text-foreground-600 mt-1">heiliao@example.com</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <span className="w-10 h-10 flex items-center justify-center shrink-0 rounded-full bg-primary-100 text-primary-600">
                  <i className="ri-wechat-line"></i>
                </span>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-900">
                    <a href="#wechat-contact">微信公众号</a>
                  </h3>
                  <p className="text-sm text-foreground-600 mt-1">搜索「黑料视频」关注我们</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <span className="w-10 h-10 flex items-center justify-center shrink-0 rounded-full bg-primary-100 text-primary-600">
                  <i className="ri-weibo-line"></i>
                </span>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-900">
                    <a href="#weibo-contact">官方微博</a>
                  </h3>
                  <p className="text-sm text-foreground-600 mt-1">@黑料视频官方微博</p>
                </div>
              </div>
            </div>

            <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-8">
              <h3 className="text-lg font-heading font-bold text-foreground-900 mb-2">商务合作</h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-5">
                如果您有商务合作、广告投放或内容推广需求，请发送邮件至 heiliao-business@example.com，我们会在24小时内回复。
              </p>
              <Link
                to="/"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-white rounded-full text-sm font-medium transition-colors whitespace-nowrap"
              >
                返回首页
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            </div>
          </div>
        </section>

        <section className="max-w-[1100px] mx-auto px-4 md:px-6 py-12 md:py-20">
          <div className="rounded-2xl overflow-hidden relative h-[280px] md:h-[360px]">
            <img
              src="https://readdy.ai/api/search-image?query=Dark%20elegant%20theater%20stage%20with%20warm%20golden%20spotlight%2C%20red%20velvet%20curtains%2C%20cinematic%20dramatic%20atmosphere%2C%20empty%20stage%20waiting%20for%20performance%2C%20luxurious%20dark%20aesthetic%2C%20theatrical%20moody%20lighting%2C%20rich%20crimson%20and%20gold%20tones&width=1800&height=800&seq=cta-about-bg&orientation=landscape"
              alt="黑料视频 - 加入我们"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-black/55"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-white max-w-2xl">
                与千万吃瓜群众一起<br />加入<em className="italic text-accent-400 not-italic font-normal">黑料视频</em>
              </h2>
              <p className="mt-4 text-white/70 text-sm md:text-base max-w-lg">
                黑料24小时不打烊，每日更新最新爆料。关注我们，吃瓜不迷路。
              </p>
              <Link
                to="/"
                className="mt-8 px-8 py-3 bg-white hover:bg-white/90 text-foreground-950 rounded-full text-sm font-semibold transition-colors whitespace-nowrap"
              >
                浏览最新黑料
              </Link>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}